import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const Bulb = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16.8421 41.1539C16.7843 40.603 17.1736 40.0827 17.7117 39.9916L24.2841 38.8794C24.8222 38.7883 25.3054 39.161 25.3633 39.7118C25.4211 40.2626 25.0318 40.783 24.4937 40.8741L17.9213 41.9863C17.3831 42.0774 16.9 41.7047 16.8421 41.1539Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15.2061 37.5499C15.1482 36.9991 15.5375 36.4788 16.0756 36.3877L25.8938 34.7262C26.432 34.6351 26.9151 35.0078 26.973 35.5586C27.0308 36.1094 26.6415 36.6298 26.1034 36.7208L16.2852 38.3824C15.7471 38.4734 15.2639 38.1007 15.2061 37.5499Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M29.2793 24.912C32.74 22.4302 35 18.3369 35 13.7077C35 6.13713 28.9558 0 21.5 0C14.0442 0 8 6.13713 8 13.7077C8 18.2355 10.1621 22.2507 13.4952 24.7467L14.1603 25.422C14.2354 25.4982 14.2979 25.5863 14.3454 25.6827L14.5443 26.0866V29.7243C14.5443 31.2015 15.7237 32.399 17.1785 32.399H25.8193C27.2741 32.399 28.4534 31.2015 28.4534 29.7243V26.1784C28.584 25.6799 28.8721 25.2335 29.2793 24.912ZM12.5723 12.5619C13.0303 8.68327 15.8405 5.51585 19.5921 4.6499C20.1241 4.5271 20.4573 3.98967 20.3364 3.44951C20.2154 2.90935 19.6861 2.57101 19.1542 2.69381C14.5883 3.74771 11.1681 7.6026 10.6107 12.3231L10.5832 12.5558C10.5183 13.1058 10.9048 13.6051 11.4464 13.671C11.9881 13.737 12.4799 13.3446 12.5448 12.7946L12.5723 12.5619Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
